import { Component } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-solutions-header-banner',
  templateUrl: './solutions-header-banner.component.html',
  styleUrl: './solutions-header-banner.component.scss',
  standalone: false
})
export class SolutionsHeaderBannerComponent {
  Images = IMAGES;
}
